/** @file Onion-skin poses at frame -2, -1, +1, +2 (OverlayInput.onionPoses order: before, then after). */
import { createPose } from '@pose2d/core/pose/createPose';
import type { Pose } from '@pose2d/core/types';
import { poseAt } from '../../../playback/poseAt';
import type { Scene } from './createScene';

const OFFSETS = [-2, -1, 1, 2] as const;

/** [] in the setup pose (`animation` < 0); otherwise the ghosts (allocated once in scene.ghosts), times clamped at 0. */
export function onionPoses(scene: Scene, animation: number, frame: number, fps: number): Pose[] {
  if (animation < 0) return [];
  const { data, scratch } = scene;
  return OFFSETS.map((offset, i) => {
    const ghost = (scene.ghosts[i] ??= createPose(data));
    poseAt(data, ghost, scratch, { kind: 'animation', anim: animation, time: Math.max(0, (frame + offset) / fps) });
    return ghost;
  });
}
